import React from 'react';

interface WordCountModalProps {
  showWordCountModal: boolean;
  onCancel: () => void;
}

const WordCountModal: React.FC<WordCountModalProps> = ({
  showWordCountModal,
  onCancel
}) => {
  if (!showWordCountModal) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onCancel}
    >
      <div 
        className="rounded-lg p-6 max-w-md w-full mx-4 relative"
        style={{ background: 'var(--surface-primary)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 transition-colors" style={{ color: 'var(--text-tertiary)' }}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h3 className="text-lg font-medium mb-4 pr-8" style={{ color: 'var(--text-primary)' }}>
          Word Count Exceeded
        </h3>
        <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
          The word count exceeds the limit.
        </p>
      </div>
    </div>
  );
};

export default WordCountModal; 